import { createContext } from 'react'
import { generateClient } from '@aws-amplify/api'

import { getCustomerDocs as getCustomerDocsQuery } from '../graphql/queries'

const CustomerDocsContext = createContext()
export default CustomerDocsContext

const ContextState = () => {
  // Migrating from Amplify V5 to V6.
  // https://docs.amplify.aws/react/migrate-v5-to-v6/migrate-graphql-api/
  const client = generateClient();

  const getDocumentation = async (docPath) => {
    const response = await client.graphql({
      query: getCustomerDocsQuery,
      authMode: 'userPool',
      variables: {
        docPath,
      },
    })
    return response.data.getDocumentation
  }

  return {
    getDocumentation,
  }
}

const CustomerDocsProvider = ({ children }) => {
  const state = ContextState()

  return (
    <CustomerDocsContext.Provider value={state}>
      {children}
    </CustomerDocsContext.Provider>
  )
}

export { CustomerDocsContext, CustomerDocsProvider }
